module.exports = __webpack_public_path__ + "static/card-project1-6857ca8c305ecd7106aa5674b086cf1c.jpg";